<template>
	<div class="flex flex-col items-center">
		<span class="font-medium uppercase">{{ $t(`contacts.groups.${name}`) }}</span>
		<div class="flex flex-col gap-y-4 py-2 my-4">
			<slot />
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "ContactUsGroup",
	props: {
		name: {
			type: String,
			default: "Group",
		},
	},
});
</script>
